import React from 'react';
import { Box } from '@mui/material';
import CreationSettingsForm from './RoleSettingPage';

export default function CreationSettingsPage(props) {
  return (
    <Box
      sx={{
        '& .MuiAccordion-root': {
          boxShadow: 'none',
          border: '1px solid #C1C7B8',
          borderRadius: '12px !important',
          overflow: 'hidden',
          mb: 1,
          bgcolor: '#FDFEFC',
          '&:before': { display: 'none' },
        },
        '& .MuiAccordionSummary-root': { minHeight: 44, bgcolor: '#F5F8F1', px: 1.5 },
        '& .MuiAccordionSummary-content': { my: 1 },
        '& .MuiAccordionDetails-root': { px: 1.5, pt: 1.25, pb: 1.5 },
        '& .MuiInputBase-root': { borderRadius: 2 },
        '& .MuiFormControl-root, & .MuiTextField-root': { minWidth: { xs: '100%', sm: 145 } },
        '& .MuiButton-root': { borderRadius: 2, textTransform: 'none' },
      }}
    >
      <CreationSettingsForm {...props} />
    </Box>
  );
}
